// extracted by mini-css-extract-plugin
module.exports = {"container":"externalLinks_container__ZTFYL","blueskyFontAwesomeAdjustment":"externalLinks_blueskyFontAwesomeAdjustment__Aq4TJ"};